import React, { useEffect, useRef } from 'react';
import { Outlet } from "react-router-dom";
import { Container } from 'reactstrap';
import Menu  from './Layout/Menu';
import axios from 'axios';
import useAuth from "../components/Utilities/Hooks/useAuth";
import LoginFooter from '../images/login_footer.png';

const NonWizardLayout = () => {
    const { auth, setAuth } = useAuth();
    const idleTimerRef = useRef(null);
    const wasIdleRef = useRef(false);
    useEffect(() => {
        refreshToken();
        const IDLE_MS = 60000;
        const startIdleTimer = () => {
            clearTimeout(idleTimerRef.current);
            idleTimerRef.current = setTimeout(() => {
                wasIdleRef.current = true;
                validateToken();
                startIdleTimer();
            }, IDLE_MS);
        };
        const onUserActivity = () => {
            if (wasIdleRef.current) {
                refreshToken();
                wasIdleRef.current = false;
            }
            startIdleTimer();
        };
        window.addEventListener("mousedown", onUserActivity);
        window.addEventListener("keydown", onUserActivity);
        window.addEventListener("scroll", onUserActivity);
        window.addEventListener("touchstart", onUserActivity);
        startIdleTimer();
        return () => {
            clearTimeout(idleTimerRef.current);
            window.removeEventListener("mousedown", onUserActivity);
            window.removeEventListener("keydown", onUserActivity);
            window.removeEventListener("scroll", onUserActivity);
            window.removeEventListener("touchstart", onUserActivity);
        };
    }, []);
    const validateToken = async () => {
        if (auth != null) {
            let form = {
                Token: localStorage.getItem("logintoken"), Email: auth.username
            }
            const response = await axios.post(
                '/api/Token/ValidateV1/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (!response.data.isTokenValid) {
                localStorage.clear();
                window.open("/login", "_self");
            }
        }
        else {
            localStorage.clear();
            window.open("/login", "_self");
        }
    }
    const refreshToken = async () => {
        if (auth != null) {
            let form = {
                Token: localStorage.getItem("logintoken"),
                UserId: auth.loggedInUserId,
                UserName: auth.username,
                Email: auth.email,
                Role: auth.role
            }
            const response = await axios.post(
                '/api/Token/RefreshToken/', JSON.stringify(form),
                {
                    headers: { 'Content-Type': 'application/json' },
                    withCredentials: true
                });
            if (!response.data.isTokenValid) {
                localStorage.clear();
                window.open("/login", "_self");
            }
            else {
            }
        }
        else {
            localStorage.clear();
            window.open("/login", "_self");
        }
    }
    return (
        <>
            <Menu />
            <div style={{ height: "82vh", overflow: "auto", marginBottom: "5vh" }}>
                <Container className="layout-body">
                    <Outlet />
                </Container>
            </div>
            <div className="footerLogin" >
                <div style={{
                    backgroundImage: `url(${LoginFooter})`,
                    backgroundSize: 'unset',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'right',
                    height: '5vh', marginTop: "-5px", marginRight: "10px"
                }}>
                </div>
            </div>
        </>
    );
}

export default NonWizardLayout
